export function isValidCoordinate(
  longitude: number,
  latitude: number
): boolean {
  // Check if inputs are numbers and not NaN
  if (
    typeof longitude !== 'number' ||
    typeof latitude !== 'number' ||
    isNaN(longitude) ||
    isNaN(latitude)
  ) {
    return false;
  }

  // Validate longitude range: -180 to +180 degrees
  if (longitude < -180 || longitude > 180) {
    return false;
  }

  // Validate latitude range: -90 to +90 degrees
  if (latitude < -90 || latitude > 90) {
    return false;
  }

  return true;
}
